
import { ApiError, Dispatcher, LibrarySourceType, LibraryTraceCrumb, ThirdPartyLibrary, ThirdPartyLibraryState, ThirdPartyLibraryTile } from '../types/ThirdPartyLibrary';
import allSettled from 'promise.allsettled';
import { MLImage, fetchFirebaseImages, fetchImageCategories, fetchImageTiles, fetchOwnLibraryImages } from './api/FirebaseDesignsApi';
import { PromiseResolution } from 'promise.allsettled';
import { PromiseRejection } from 'promise.allsettled';
import { getParentTile } from './reducer';
import { OWN_LIBRARY } from '../ImageLibrary';
import { WizardScreenType } from '../../editor/useFabricWizard';

export const ACTIONS = {
    SETUP_LIBRARY: 'setup_image_library',
    SET_LIBRARY_SOURCE: 'set_library_source',
    ADD_NAV_TRACE: 'add_nav_trace',
    REMOVE_NAV_TRACE: 'remove_nav_trace',
    UPDATE_PROGRESS_STATE: 'update_progress_state',
    ADD_TO_LIBRARY: 'add_to_library',
    CLEAR_NAV_TILES: 'clear_nav_tiles',
    CLEAR_ROOT_ID: 'clear_root_id',
    OPEN_FOR_SELECTION: 'open_for_selction',
    SET_SCREEN_TYPE: 'set_screen_type',
    CLOSE_VIEW: 'close_view',
    IMAGE_CONSUMED: 'image_consumed',
    UPDATE_IMAGE_FILTERS: 'update_image_filters',
}

export const openImageLibraries = (categoryId?: number | string, categoryName?: string, patternContainer?: boolean) => {
    return {
        type: ACTIONS.OPEN_FOR_SELECTION,
        payload: categoryId && { categoryId, categoryName, patternContainer }
    }
}

export const setImageLibraryImageConsumed = () => ({
    type: ACTIONS.IMAGE_CONSUMED
})

export const setScreenType = (screenType: WizardScreenType) => ({
    type: ACTIONS.SET_SCREEN_TYPE,
    payload: {
        screenType
    }
})

export const closeImageLibraries = (parentWindowScrollPosition:number|null)=>({
    type: ACTIONS.CLOSE_VIEW,
    payload: {
        parentWindowScrollPosition
    }
})

export const clearNavTiles = ()=>({
    type: ACTIONS.CLEAR_NAV_TILES
})

export const clearRootCategoryId = ()=>({
    type: ACTIONS.CLEAR_ROOT_ID
})

export const addToNavTrace = (category: LibraryTraceCrumb) => ({
    type: ACTIONS.ADD_NAV_TRACE,
    payload: category
})

export const removeFromNavTrace = (category: LibraryTraceCrumb) => ({
    type: ACTIONS.REMOVE_NAV_TRACE,
    payload: category
})

export const addToLibrary = (source: string, category: LibraryTraceCrumb, tiles: ThirdPartyLibraryTile[]) => ({
    type: ACTIONS.ADD_TO_LIBRARY,
    payload: {
        source,
        category,
        tiles,
    }
})

export const updateImageFilters = (filters:any)=>({
type: ACTIONS.UPDATE_IMAGE_FILTERS,
payload: {filters}
})

export const setSelectedSource = (source: LibrarySourceType) => ({
    type: ACTIONS.SET_LIBRARY_SOURCE,
    payload: source,
})

export const setProgress = (source: string) => ({
    type: ACTIONS.UPDATE_PROGRESS_STATE,
    payload: {
        source,
        progress: {
            inProgress: true
        }
    }
})

export const setError = (source: string, errorMessage: string) => ({
    type: ACTIONS.UPDATE_PROGRESS_STATE,
    payload: {
        source,
        progress: {
            result: 'failure',
            inProgress: false,
            displayMesssage: errorMessage
        }
    }
})

export const setSuccess = (source: string, successMessage?: string) => ({
    type: ACTIONS.UPDATE_PROGRESS_STATE,
    payload: {
        source,
        progress: {
            result: 'success',
            inProgress: false,
            displayMesssage: successMessage
        }
    }
})

export const setUpLibraryForSource = (source: string, tiles: ThirdPartyLibraryTile[]) => ({
    type: ACTIONS.SETUP_LIBRARY,
    payload: {
        source,
        tiles
    }
})

export const fetchSubTiles = (source: LibrarySourceType, traceCrumb: LibraryTraceCrumb, pageRequested: number) =>
async (dispatch: Dispatcher, getState: () => ({
        thirdPartyLibrary: ThirdPartyLibraryState, fbdata:any
})) => {
        const { thirdPartyLibrary: { libraries },fbdata:{imageLibraryFilters}  } = getState()

        const { trace, progressState } = libraries[source];

        if (progressState?.inProgress) {
            return
        }

    const isMaster = !!(trace.length && trace[0].id==='Master')

    const doesTraceExist = trace.find(crumb => crumb.id === traceCrumb.id)

    if (doesTraceExist) {
        //dispatch(removeFromNavTrace(traceCrumb))
    } else {
        dispatch(addToNavTrace(traceCrumb))
    }
    dispatch(setProgress(source))

    try {
        const { thirdPartyLibrary: { libraries } } = getState()

        const trace = libraries[source].trace;    

            const { parentTile } = getParentTile(trace, libraries[source])

                    let tilesToSet: ThirdPartyLibraryTile[]

            switch (source) {
                case OWN_LIBRARY:
                    const { page } = parentTile?.pagination || { page: 1 }

                    tilesToSet = pageRequested < page ? [] : (parentTile && parentTile.pagedTiles && parentTile.pagedTiles[page] || [])

                    if (parentTile && tilesToSet.length) {
                        parentTile.tiles = [...parentTile.tiles || [], ...tilesToSet];
                        parentTile.pagination = {
                            page: pageRequested < page ? page : page + 1
                        }
                    }

                    dispatch(addToLibrary(source, traceCrumb, parentTile?.tiles || []))
                    break;
                case OWN_LIBRARY + '_searchResults':
                    let filtersToApply:{[key:string]:Set<string>}|undefined = undefined ;
                    const filters = JSON.parse(traceCrumb.id as string);
                    let filteredPool:ThirdPartyLibraryTile[] = [];
                    let searchPool:ThirdPartyLibraryTile[] = [];

                    const { tiles, trace } = libraries[OWN_LIBRARY]

                    if(tiles && tiles.length){
                        let libLevel = tiles[0];
                        while(!libLevel.isPatternContainer && libLevel.pagedTiles?.length){
                            libLevel = libLevel.pagedTiles[0][0]
                        }
                        
                        libLevel.pagedTiles?.forEach(page=>{
                            searchPool = searchPool.concat(page);
                        })

                        // const remainingFilters = imageLibraryFilters.filter((libFilter:any)=>{
                        //     return !filters.find((filter:any) => filter.filterKey === libFilter.filterKey)
                        // })
                        const remainingFilters = imageLibraryFilters

                        
                        filteredPool = searchPool.filter(tile=>{
                            let isSatisfied = true;
                            filters.forEach((filter:any)=>{
                                if(!(tile.filter && tile.filter[filter.filterKey] && tile.filter[filter.filterKey].includes(filter.filterValue))){
                                    isSatisfied = isSatisfied && false
                                }
                            })
                            if(isSatisfied && filters?.length){
                                remainingFilters.forEach((remainingFilter:any)=>{
                                    if(!filtersToApply){
                                        filtersToApply = {} ;
                                    }
                                    if(tile.filter[remainingFilter.filterKey]?.length){
                                        if(!filtersToApply[remainingFilter.filterKey]){
                                            filtersToApply[remainingFilter.filterKey]=new Set()
                                        }
                                        tile.filter[remainingFilter.filterKey].forEach((val:string)=>filtersToApply && filtersToApply[remainingFilter.filterKey].add(val))
                                    }
                                })
                            }
                            return isSatisfied
                        })
                    }

                    dispatch(updateImageFilters(filtersToApply))
                    dispatch(addToLibrary(source, traceCrumb, filteredPool || []))
                    break;
            case 'patternDesigns_searchResults':
            case 'patternDesigns':
                    if (isMaster) {
                        const { page } = parentTile?.pagination || { page: 1 }
                        tilesToSet = pageRequested < page ? [] : (parentTile && parentTile.pagedTiles && parentTile.pagedTiles[page]||[])
                        if (parentTile && tilesToSet.length) {
                            parentTile.tiles = [...parentTile.tiles || [], ...tilesToSet];
                            parentTile.pagination = {
                                page: pageRequested < page ? page : page + 1
                            }
                        }
                    } else if (!traceCrumb.isPatternContainer) {
                        tilesToSet = (parentTile?.tiles && parentTile?.tiles.length && parentTile?.tiles) || await fetchImageCategories({ categoryId: traceCrumb.id as any }) || []
                        parentTile && (parentTile.tiles = tilesToSet)
                    } else {
                        const { page } = parentTile?.pagination || { page: 0 }
                        tilesToSet = pageRequested < page ? [] : await fetchImageTiles({
                        categoryId: traceCrumb.id as any, 
                            offset: page,
                        term: traceCrumb.term
                        }) || []
                        if (parentTile && tilesToSet.length) {
                            parentTile.tiles = [...parentTile.tiles || [], ...tilesToSet];
                            parentTile.pagination = {
                                page: pageRequested < page ? page : page + 1
                }
                    }
                }

                    dispatch(addToLibrary(source, traceCrumb, parentTile?.tiles || []))
                break;
        }
        dispatch(setSuccess(source))
        } catch (error) {
            dispatch(addToLibrary(source, traceCrumb, []))
        dispatch(setError(error.source, error.errorMessage))
    }

}

export const displayThirdPartyLibrary = (source:LibrarySourceType)=>{

}

export const setUpThirdPartyLibraries = ({ sources, id, isPatternContainer, selectedSource,openLibrary }: { sources: string[], id?: number | string, isPatternContainer?: boolean, selectedSource?: LibrarySourceType, openLibrary?:(crumb:LibraryTraceCrumb)=>void }) =>
async (dispatch: Dispatcher, getState: () => ({
        thirdPartyLibrary: ThirdPartyLibraryState, imgslib: any, apikey: string, fbdata:any
})) => {
    const searchSources = sources.map(source=>`${source}_searchResults`);

        const { imgslib, apikey, fbdata:{imageLibraryFilters} } = getState();

    sources.push(...searchSources);
    
    sources.forEach((source) => dispatch(setProgress(source)));

    const fetchPromises: Promise<ThirdPartyLibraryTile[]>[] = []

    const queriedSources: LibrarySourceType[] = []

    sources.forEach((source) => {
        switch (source as LibrarySourceType) {
            case 'patternDesigns':
                const categoryId = isPatternContainer ? undefined : id;
                const patternId = isPatternContainer ? id : undefined;
                queriedSources.push('patternDesigns')
                fetchPromises.push(fetchImageCategories({ requiresAuthorization: false, categoryId, patternId }))
                break;
            case 'patternDesigns_searchResults':
                queriedSources.push('patternDesigns_searchResults');
                fetchPromises.push(Promise.resolve([]));
                break;   
                case OWN_LIBRARY: {
                    const categoryId = isPatternContainer ? undefined : id;
                    const patternId = isPatternContainer ? id : undefined;
                    queriedSources.push(OWN_LIBRARY)
                    fetchPromises.push(fetchOwnLibraryImages(apikey,imageLibraryFilters))
                    break;
                }
                case OWN_LIBRARY + '_searchResults':
                    queriedSources.push(OWN_LIBRARY + '_searchResults' as LibrarySourceType);
                    fetchPromises.push(Promise.resolve([]));
                    break;
        }
    })

    const results = await allSettled(fetchPromises)

        let crumbForLib:LibraryTraceCrumb|undefined = undefined;

    results.forEach((result, index) => {
        const source = queriedSources[index];
        if (result.status === 'fulfilled') {
            const { value } = result as PromiseResolution<ThirdPartyLibraryTile[]>

                if (source === OWN_LIBRARY) {
                    crumbForLib = {
                        id: value[0].id,
                        name: value[0].name,
                        isCategory:false,
                        isPatternContainer: true
                    }
                }

            dispatch(setUpLibraryForSource(source, value))
            dispatch(setSuccess(source))
        } else {
            const { reason } = result as PromiseRejection<ApiError>
            dispatch(setError(source, reason.errorMessage))
            dispatch(setUpLibraryForSource(source, []))
        }
    })

        if (selectedSource) {
            dispatch(setSelectedSource(selectedSource))
        }

        if(openLibrary && crumbForLib){
            openLibrary(crumbForLib)
        }
}

export const setUpThirdPartyLibrariesSearch = (source: LibrarySourceType, term: string, ) => ({
    
    type: ACTIONS.SETUP_LIBRARY,
    payload: {
        source,
        tiles:[{
            id: term,
            isCategory: true,
            isPatternContainer: true,
            name: term,
            thumbnail: {
                source:''
            },
            pagedTiles:[],
            tiles:[]
        }]
    }
})

export const setUpThirdPartyCategory = (source: LibrarySourceType, categoryId:number|string, name:string, isPatternContainer:boolean) => ({

    type: ACTIONS.SETUP_LIBRARY,
    payload: {
        source,
        tiles: [{
            id: categoryId,
            isCategory: true,
            isPatternContainer,
            name,
            thumbnail: {
                source: ''
            },
            pagedTiles: [],
            tiles: []
        }] 
    }
})
